export default __webpack_public_path__ + "static/streamline-expense-reporting-for-a-tech-company-c3849a446a427788be9092bfd271927a.jpg";